import React from 'react';
import ReactDOM from 'react-dom';
import BorderedBox from '../../../../shared/web/layout/BorderedBox';
import FormTemplate from '../../../../shared/uibuilder/form/FormTemplate';
import Checkbox from '../../../../shared/uibuilder/form/input/Checkbox';
import Separator from '../../../../shared/web/uitheme/form/Separator';
import styles from './TypeFilter.module.scss';
import useAuthorizationChecker from '../../../../shared/authorization/authorizationChecker';
import { FormFieldsData } from '../../../../shared/uibuilder/form/FormContext';
import { TeamPermission } from 'nekst-api';
import { PlanTasksTypeFilterValue, usePlanTasksTypeFilterService } from 'features/tasks-forms';
import useFeatureToggleService from 'feature-toggle';
import { TasksGroupFilterForm } from './TasksGroupFilter';

export default function TypeFilter(props: {
  forceShowKeyDatesOnly?: boolean,
  showNonAiTasksOnlyOption?: boolean,
}) {
  const container = document.getElementById('filter1');

  const typeFilterService = usePlanTasksTypeFilterService();

  const { isGranted } = useAuthorizationChecker();
  const featureToggle = useFeatureToggleService();

  const forceShowKeyDatesOnly = props.forceShowKeyDatesOnly;

  if (container) {
    return ReactDOM.createPortal(
      <BorderedBox
        title="Display"
        className={styles.filter}
        collapsible
        sectionId="display"
        pageContext="plan-tasks"
      >
        <FormTemplate
          submitFormFunc={async (data: FormFieldsData) => {
            typeFilterService.setFilterValue(data as PlanTasksTypeFilterValue);
          }}
          initialData={typeFilterService.getFilterValue()}
          submitOnEachChange
          buttons={null}
        >
          <Checkbox source="showStandardTasks" label="Standard Tasks" />
          <Checkbox source="showEmailTasks" label="Email Tasks" />
          {
            isGranted(TeamPermission.USE_SMS_TASKS_FEATURE)
              ? (
                <Checkbox source="showSmsTasks" label="SMS Tasks" />
              )
              : null
          }
          {
            featureToggle.isPlanEventTasksEnabled()
              ? (
                <Checkbox source="showEventTasks" label="Appointment Tasks" />
              )
              : null
          }
          <Separator />
          <Checkbox
            source="showKeyDatesOnly"
            label="Key Dates Only"
            value={forceShowKeyDatesOnly ? true : undefined}
            isDisabled={forceShowKeyDatesOnly}
          />
          <Checkbox source="showRoadmapOnly" label="Roadmap Tasks Only" />
          <Checkbox source="showPrivateOnly" label="Private Tasks Only" />
          <Checkbox source="showBusinessDaysOnly" label="Business Days Only" />
          {props.showNonAiTasksOnlyOption && (<Checkbox source="showNonAiTasksOnly" label="Non-AI Tasks Only" />)}
        </FormTemplate>
        <Separator marginSize="big" />
        <TasksGroupFilterForm />
      </BorderedBox>,
      container,
    );
  } else {
    return null;
  }
}
